import { useBucket } from '@mc/experiments-react'
import { PEN_7367_FLAG } from './constants'

export const useIsPen7367Variant = () =>
  useBucket(PEN_7367_FLAG)?.startsWith('variant')
